export default "__VITE_ASSET__fc3d412e__"